import {useMediaQuery, useTheme} from '@mui/material'

/**
 * Returns true when the viewport is considered "mobile" (below MUI's `sm`
 * breakpoint, i.e. < 600px by default).
 *
 * Single source of truth for mobile detection in JS. Use this instead of
 * inlining `useMediaQuery(useTheme().breakpoints.down('sm'))` so the
 * breakpoint can be changed in one place if the convention evolves.
 *
 * Note: the CSS side cannot share this value — `@media` queries do not
 * accept CSS custom properties. CSS files keep `@media (max-width: 600px)`.
 */
export const useIsMobile = (): boolean => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('sm'))
}
